import { render, staticRenderFns } from "./TablaResumenPaquetesDevueltos.vue?vue&type=template&id=022b2163"
import script from "./TablaResumenPaquetesDevueltos.vue?vue&type=script&lang=js"
export * from "./TablaResumenPaquetesDevueltos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports